import { useProfile } from './useProfile'
import type { Asset } from '../../types'

/**
 * The caller's own asset row from GET /me/asset-data. The BFF returns multiple
 * asset rows; this picks the one matching `caller.assetId`, falling back to the
 * first record. Both are undefined until the profile query resolves (or
 * rehydrates from the localStorage mirror — see useProfile).
 */
export function useCallerAsset(): { asset?: Asset; assetId?: string } {
  const { data } = useProfile()
  const assetId = data?.caller?.assetId
  const asset =
    data?.assets?.find((a) => String(a.assetsid) === assetId) ??
    data?.assets?.[0]
  return { asset, assetId }
}
